import Vue from 'vue';
import Vuex from 'vuex';
import Axios from 'axios';
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);
const getDefaultState = () => {
  return {
    token: ''
  };
};
const getDefaultCustomerState = () => {
  return {
    customerToken: ''
  };
};
export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: Object.assign(getDefaultState(), getDefaultCustomerState()),
  getters: {
    isLoggedIn: state => {
      return !!state.token;
    },
    isCustomerLoggedIn: state => {
      return !!state.customerToken;
    },
    getUser: state => {
      return (state.token)
    },
    getCustomer: state => {
      return (state.customerToken)
    }
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_CUSTOMER_TOKEN: (state, token) => {
      state.customerToken = token;
    },
    RESET: state => {
      Object.assign(state, getDefaultState());
    },
    RESET_CUSTOMER: state => {
      Object.assign(state, getDefaultCustomerState());
    },
  },
  actions: {
    login: ({ commit, dispatch }, { token }) => {
      commit('SET_TOKEN', token)
      // set auth header
      Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    },
    loginCustomer: ({ commit, dispatch}, {token}) => {
      commit('SET_CUSTOMER_TOKEN', token)
      Axios.defaults.headers.common['AuthorizationCustomer'] = `PrimeCustomerLogging ${token}`;
    },
    logout: ({ commit }) => {
      commit('RESET', '');
    },
    logoutCustomer: ({ commit }) => {
      commit('RESET_CUSTOMER', '');
    }
  }
});


// WEBPACK FOOTER //
// ./src/store.js